import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Tools from "@/components/Tools";
import Benefits from "@/components/Benefits";
import Testimonial from "@/components/Testimonial";
import FAQ from "@/components/FAQ";
import CTA from "@/components/CTA";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";

const Landing = () => {
  return (
    <main className="min-h-screen bg-white text-[#202A36]" data-testid="landing-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Tools />
      <Benefits />
      <Testimonial />
      <FAQ />
      <CTA />
      <Footer />
      <Chatbot />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
